<template>
  <main class="cover-auth">
    <div class="widget-auth">
      <a href="#">
        <div class="text-center mb-8">
          <img src="/public/images/logo-wide.svg" class="auth-logo" />
        </div>
      </a>

      <h2 class="font-semibold text-center my-6">Mot de passe oublié</h2>
      <p class="text-read text-grey-600 text-center pb-5">
        Un lien pour réinitialiser votre code de sécurité vous a été envoyé.
      </p>

      <form class="form" @submit.prevent="handleSubmit">
        <div class="form-field-floating xl reactive active rounded-50 text-center mb-5">
          <input 
            type="text" 
            class="form-input text-center" 
            name="identifiant" 
            id="identifiant" 
            v-model="identifiant"
            placeholder=""
          >
          <label for="identifiant">Email ou numéro de téléphone <b class="color-danger">*</b></label>
        </div>
        
        <button 
          type="submit" 
          class="btn lg w-100 flex-center mt-5 mb-7"
          :disabled="isSubmitting"
        >
          <img src="/public/icons/icon-menu-securite.svg" class="btn-icon" alt="" />
          <span>{{ isSubmitting ? 'Envoi en cours...' : 'Réinitialiser' }}</span>
        </button>
        
        <router-link to="/signin">
          <h5 class="text-primary-color text-center">Voulez-vous annuler ?</h5>
        </router-link>
      </form>
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'
import authService from '@/services/authService'
import { showAlert } from '@/utils/swal'

export default defineComponent({
  name: 'ForgetPassword',
  setup() {
    const router = useRouter()
    const identifiant = ref('')
    const isSubmitting = ref(false)

    const validateEmail = (email: string): boolean => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(email)
    }

    const validatePhone = (phone: string): boolean => {
      const phoneRegex = /^[\d\s+\-()]+$/
      return phoneRegex.test(phone) && phone.replace(/\D/g, '').length >= 8
    }

    const handleSubmit = async () => {
      if (!identifiant.value.trim()) {
        await showAlert.warning('Veuillez saisir votre email ou numéro de téléphone')
        return
      }

      const isEmail = identifiant.value.includes('@')
      const isValid = isEmail 
        ? validateEmail(identifiant.value) 
        : validatePhone(identifiant.value)

      if (!isValid) {
        await showAlert.warning('Veuillez saisir un email ou un numéro de téléphone valide')
        return
      }

      isSubmitting.value = true

      try {
        // Appel à l'API forgot password
        const response = await authService.forgotPassword(identifiant.value)

        if (response.status === 0) {
          // Succès - Code OTP envoyé
          // Stocker l'identifiant pour la suite
          sessionStorage.setItem('resetPasswordIdentifier', identifiant.value)
          
          // await showAlert.success('Un code de vérification a été envoyé à votre email')

          // Rediriger vers la page OTP
          router.push('/auth/forget-password-reset')
        } else {
          await showAlert.error(response.message || 'Erreur lors de l\'envoi du code')
        }
      } catch (error) {
        console.error('Erreur:', error)
        await showAlert.error('Une erreur est survenue. Veuillez réessayer.')
      } finally {
        isSubmitting.value = false
      }
    }

    return {
      identifiant,
      isSubmitting,
      handleSubmit
    }
  }
})
</script>

<style scoped>
.auth-logo {
  max-width: 200px;
  height: auto;
}

.rounded-50 {
  border-radius: 50px;
}

.text-center {
  text-align: center;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
